import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import WrapperList from "../../../Nano/WrapperList.js";
import TitleCard from "../../../Nano/TitleCard.js";
import Grid from "../../../Macro/Grid.js";

const StyledThumbsBlock = styled(NanoFlex)`
  .noBorderWrapper {
    border: none;
    padding: 0;
  }

  .thumbsWrapper {
    margin: 4px 0;
    padding: 8px 0;
    .titleContainer {
      margin-left: 6px;
    }

    .grid {
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
      @media only screen and (max-width: 1680px) {
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
      }
    }
  }

  .titleWrapper {
    h5 {
      width: 100%;
    }
  }

  @media only screen and (max-width: 800px) {
    flex-direction: column;
    .thumbsWrapper {
      padding: 0;
      margin: 0;
      .grid {
        grid-template-columns: repeat(auto-fill, minmax(50%, 1fr));
      }
    }
  }
`;

export class ThumbsBlock extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledThumbsBlock className="thumbsContainer" justifyContent={"flex-start"} alignItems={"flex-start"}>
        {this.props.also && this.props.also.length > 0 && (
          <WrapperList simple className="noBorderWrapper thumbsWrapper" justifyContent={"flex-start"} alignItems={"flex-start"}>
            <TitleCard simpleTitle={this.translation.card.also} />
            <Grid data={this.props.also} row={2} type={"SubGenre"} />
          </WrapperList>
        )}
        {this.props.related && this.props.related.length > 0 && (
          <WrapperList simple className="noBorderWrapper thumbsWrapper" justifyContent={"flex-start"} alignItems={"flex-start"}>
            <TitleCard simpleTitle={this.translation.card.related} />
            <Grid data={this.props.related} row={2} />
          </WrapperList>
        )}
      </StyledThumbsBlock>
    );
  }
}

//Set default props
ThumbsBlock.defaultProps = {
  card: {},
};

export default ThumbsBlock;

// --- // Documentation // --- //
/*
  import ThumbsBlock from './../Partial/ThumbsBlock.js';
  
  <ThumbsBlock/>
  */
